import React, { useState, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box } from '@mui/material';
import { format, parse, isValid } from 'date-fns';
import { es } from 'date-fns/locale'; 
import { esES } from '@mui/x-date-pickers/locales';

const DateSingleFilter = ({ onDateChange, selectedDate }) => {
  const [dateValue, setDateValue] = useState(null);

  useEffect(() => {
    if (selectedDate) {
      try {
        const parsedDate = parse(selectedDate, 'yyyy-MM-dd', new Date());
        if (isValid(parsedDate)) {
          setDateValue(parsedDate);
        } else {
          setDateValue(null);
        }
      } catch (error) {
        console.error('Error al parsear fecha:', error);
        setDateValue(null);
      }
    } else {
      setDateValue(null);
    }
  }, [selectedDate]);

  const handleDateChange = (date) => {
    setDateValue(date);
    
    if (date && isValid(date)) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      onDateChange(formattedDate);
    } else {
      onDateChange('');
    }
  };

  const sharedDateFieldSx = {
    '& .MuiOutlinedInput-root': {
      height: 40,
      borderRadius: 2,
      color: '#333',
      '& fieldset': {
        border: '1px solid #D1D5DB !important',
      },
      '&:hover fieldset': {
        border: '1px solid #D1D5DB !important',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #D1D5DB !important',
        boxShadow: 'none',
        outline: 'none',
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.875rem',
      '&.Mui-focused': {
        color: '#000',
      },
    },
    '& .MuiInputBase-input': {
      padding: '10px 14px',
      fontSize: '0.875rem',
      color: '#000',
    },
  };

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDateFns}
      adapterLocale={es}
      localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box 
        sx={{ mt: 0.5 }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()} 
      > 
        <DatePicker
          label="Seleccionar fecha"
          value={dateValue}
          onChange={handleDateChange}
          inputFormat="dd/MM/yyyy"
          mask="__/__/____"
          slotProps={{
            textField: {
              fullWidth: true,
              size: 'small',
              color: 'inherit', 
              sx: sharedDateFieldSx,
              onClick: (e) => e.stopPropagation(), 
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DateSingleFilter;